function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formOptions from '@/views/hr/archives/mixins/index.js';
import { getPerfectIndex as _getPerfectIndex, putPerfectAgree as _putPerfectAgree, putPerfectRefuse as _putPerfectRefuse } from '@/api/user';
export default {
  name: 'one',
  components: {
    LeftNavigation: function LeftNavigation() {
      return import('@/views/hr/archives/components/LeftNavigation.vue');
    },
    formItemDataList: function formItemDataList() {
      return import('@/views/hr/archives/components/formItemDataList.vue');
    }
  },
  props: {},
  mixins: [formOptions],
  data: function data() {
    return {
      initData: {
        componentName: 'addDrawerIsShow',
        type: 'add'
      },
      user: '个人简历',
      imageUrl: '',
      list: [],
      h_list: [],
      loading: true,
      saveLoading: false,
      uid: '',
      uidUrl: '',
      showMore: false,
      total: true,
      page: 1,
      limit: 7
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.getPerfectIndex();
    this.getRefuse();
    setTimeout(function () {
      _this.$refs.formItemData.getResume();
    }, 200);
  },
  methods: {
    pageJump: function pageJump(id, index) {
      this.$nextTick(function () {
        document.getElementById(index).scrollIntoView({
          behavior: 'smooth',
          inline: 'start'
        });
      });
    },
    getScroll: function getScroll(event) {
      var scrollHeight = event.target.scrollHeight;
      var scrollTop = event.target.scrollTop;
      var clientHeight = event.target.clientHeight;
      var scrollBottom = scrollHeight - scrollTop - clientHeight;
      this.showMore = scrollBottom < 1;
      if (scrollBottom < 1 && this.total) {
        this.getRefuse(1);
      }
    },
    getPhoto: function getPhoto(val) {
      this.imageUrl = val;
      this.loading = false;
    },
    getPerfectIndex: function getPerfectIndex() {
      var _this2 = this;
      this.$store.commit('app/SET_PARENTCUR', 100);
      var data = {
        status: 0
      };
      _getPerfectIndex(data).then(function (res) {
        _this2.list = res.data.list;
      });
    },
    // 同意
    putPerfectAgree: function putPerfectAgree(data) {
      var _this3 = this;
      _putPerfectAgree(data.id).then(function (res) {
        _this3.getPerfectIndex();
        _this3.page = 1;
        _this3.getRefuse();
      });
    },
    // 拒绝
    putPerfectRefuse: function putPerfectRefuse(data) {
      var _this4 = this;
      _putPerfectRefuse(data.id).then(function (res) {
        _this4.getPerfectIndex();
        _this4.page = 1;
        _this4.getRefuse();
      });
    },
    // 记录
    getRefuse: function getRefuse(val) {
      var _this5 = this;
      if (val == 1) {
        this.page = this.page + 1;
      }
      var data = {
        page: this.page,
        limit: this.limit
      };
      _getPerfectIndex(data).then(function (res) {
        if (val === 1) {
          _this5.h_list = [].concat(_toConsumableArray(_this5.h_list), _toConsumableArray(res.data.list));
        } else {
          _this5.h_list = res.data.list;
        }
        _this5.total = res.data.list.length > 4;
      });
    },
    // 获取个人头像
    getImageUrl: function getImageUrl(val) {
      this.imageUrl = val;
    },
    // 保存简历
    submit: function submit() {
      this.saveLoading = true;
      this.$refs.formItemData.saveResume(this.imageUrl);
    },
    // 保存简历
    hiddenSave: function hiddenSave() {
      this.saveLoading = false;
    },
    // 重置
    restFn: function restFn() {
      location.reload();
    }
  }
};